const removeArrayItemAt = (arr: Array<any>, index = -1) => {
  const tmp = [...arr];
  if (index > -1) {
    tmp.splice(index, 1);
  }

  return tmp;
};

export default removeArrayItemAt;
